{
  "marketing": {
    "footerProduct": "Produit",
    "navForDevelopers": "Développeurs",
    "navForPm": "Pour les PM",
    "navHome": "Accueil",
    "navOpenApp": "Ouvrir l'app →",
    "navStart": "Commencer gratuitement →",
    "navPricing": "Tarifs"
  },
  "homepage": {
    "edition": "VOL. 1 · ÉDITION 2026",
    "footerBlurb": "Un incubateur d'idées nativement agentique. Bâti sur un agent Rust auto-hébergé, Postgres + pgvector et des références stockées sur S3. SaaS propriétaire — vos données s'exportent en markdown dès que vous le demandez.",
    "footerSignIn": "CONNEXION",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerMagicLink": "LIEN MAGIQUE",
    "footerEdition": "VOL. 1 · N° 1 · ACCÈS ANTICIPÉ MONDIAL · ÉDITION 2026",
    "footerPrivacy": "CONFIDENTIALITÉ",
    "footerTerms": "CONDITIONS",
    "footerContact": "CONTACT"
  }
}
